module.exports = __webpack_public_path__ + "static/img/7.16e4221.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/7.png
// module id = dIWU
// module chunks = 0